class ShopByGoalHexagonInfo extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.shop-by-goal-hexagon-info__hexagon').forEach((hexagon,index) => {
      hexagon.addEventListener('mouseenter', (e) => {
        let hexagonElement = e.target;
        if (!e.target.classList.contains('shop-by-goal-hexagon-info__hexagon')) {
          hexagonElement = e.target.closest('.shop-by-goal-hexagon-info__hexagon');
        }
        if (!hexagonElement.classList.contains('active')) {
          const active = this.querySelector('.shop-by-goal-hexagon-info__hexagon.active');
          if (active && active !== hexagonElement) {
            active.classList.remove('active');
          }
          hexagonElement.classList.add('active');
        }
      });
      hexagon.addEventListener('mouseleave', (e) => {
        let hexagonElement = e.target;
        if (!e.target.classList.contains('shop-by-goal-hexagon-info__hexagon')) {
          hexagonElement = e.target.closest('.shop-by-goal-hexagon-info__hexagon');
        }
        if (hexagonElement.classList.contains('active')) {
          hexagonElement.classList.remove('active');
        }
      });
    });

  }

}

customElements.define('shop-by-goal-hexagon-info', ShopByGoalHexagonInfo);
